export default "__VITE_ASSET__a6f5c87a__"